








































import Vue, { PropOptions } from 'vue';
import dayjs from 'dayjs';

import SInputSelect from '@stratumfive/ui-baseplate/src/components/SInputSelect/SInputSelect.vue';
import SDialog from '@stratumfive/ui-baseplate/src/components/SDialog/SDialog.vue';
import SButton from '@stratumfive/ui-baseplate/src/components/SButton/SButton.vue';

import EventBus from '../../EventsBus';
import { SubmissionVersion } from '../types/FormDefinition';

interface VersionSelectItem {
  text: string;
  value: string | number;
}

export default Vue.extend({
  name: 'VersionSelector',
  components: {
    SInputSelect,
    SDialog,
    SButton,
  },
  props: {
    versions: {
      type: Array,
      required: false,
      default: () => [],
    } as PropOptions <SubmissionVersion[]>,
  },
  inject: ['latestVersion', 'currentVersion'],
  data(): any {
    return {
      versionModel: '',
      confirmationVisible: false,
    };
  },
  computed: {
    latestVersionInstance(): { updated: string, version: number } {
      return {
        updated: `${dayjs().format()}`,
        version: this.latestVersion().version,
      };
    },
    currentSubmissionInstance(): SubmissionVersion {
      return this.currentVersion();
    },
    versionInstances(): VersionSelectItem[] {
      const { latestVersionInstance } = this;
      return [latestVersionInstance].concat(this.versions);
    },
    versionOptions(): VersionSelectItem[] {
      return this.versionInstances.map((instance) => ({
        text: `${instance.version} (${dayjs(instance.updated).format('DD/MM/YYYY - HH:mm')})`,
        value: instance.version,
      }));
    },
  },
  created() {
    const initialVersionModel = this.versionOptions
      .find((versionInstance) => versionInstance.value === this.currentSubmissionInstance.version);

    if (initialVersionModel) {
      this.versionModel = initialVersionModel.value;
    }
  },
  methods: {
    /**
     * Check to see whether we should show a warning message for the
     * version change (if it will wipe existing data).
     */
    handleVersionSelected(newVersion: number): void {
      if (newVersion === this.currentSubmissionInstance.version) return;

      if (this.currentSubmissionInstance.version === this.latestVersionInstance.version) {
        this.confirmationVisible = true;
      } else {
        this.handleVersionChange();
      }
    },
    /**
     * Emit an event bus method for the Form class to pick up with the
     * new version parameters.
     */
    handleVersionChange(): void {
      this.confirmationVisible = false;

      const versionToEmit = this.versionInstances
        .find((instance) => instance.version === this.versionModel);

      EventBus.$emit('versionChanged', versionToEmit);
    },
    /**
     * The version is enforced here to swtich back to the current version
     * should the user cancel switching submission versions.
     */
    handleDialogClose(): void {
      this.versionModel = this.currentSubmissionInstance.version;
    },
  },
});

